import { SxProps } from "@mui/material";

export const sxTeleorientacaoSubtitle: SxProps = {
    color: '#4C4C4C',
    fontFamily: 'Unimed-Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%',
}

export const sxTeleorientacaoAvailability: SxProps = {
    color: '#4C4C4C',
    fontFamily: 'Unimed-Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '150%',
}

export const sxButtonTeleorientacao: SxProps = {
    borderRadius: '80px',
    height: '44px',
    padding: '24px 32px',
    '@media (max-width: 720px)': {
        width: 'stretch'
    }
}

export const sxButtonTeleorientacaoCard: SxProps = {
    borderRadius: '80px',
    height: '44px',
    padding: '24px 32px',
    '@media (max-width: 720px) or ((min-width: 900px) and (max-width: 1150px))': {
        width: 'stretch'
    }
}

const createSxTypographyTeleorientacao = (color: string, fontStyle: string): SxProps => ({
    color,
    fontFamily: 'Unimed-Sans',
    fontSize: '16px',
    whiteSpace: 'pre-wrap',
    fontStyle,
    fontWeight: '400',
    lineHeight: '150%',
    marginRight: 1,
})

export const sxTypographyTeleorientacao: SxProps = createSxTypographyTeleorientacao('#4C4C4C', 'normal');
export const sxTypographyTeleorientacaoRed: SxProps = createSxTypographyTeleorientacao('#D84141', 'italic');

const createSxTypographyTeleorientacaoBold = (color: string): SxProps => ({
    color,
    fontFamily: 'Unimed-Sans',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '150%',
    height: 'max-content',
    marginRight: 1,
})

export const sxTypographyTeleorientacaoBold: SxProps = createSxTypographyTeleorientacaoBold('#383838');
export const sxTypographyTeleorientacaoBoldGreen: SxProps = createSxTypographyTeleorientacaoBold('#00995D');
export const sxTypographyTeleorientacaoBoldRed: SxProps = createSxTypographyTeleorientacaoBold('#D84141');

export const sxBoxFlexWrap: SxProps = {
    display: 'flex',
    flexWrap: 'wrap',
}

export const sxMargin32px: SxProps = {
    margin: '32px 0px',
}

export const sxFormControlLabelTeleorientacao: SxProps = {
    '.MuiFormControlLabel-label': {
        fontSize: '14px'
    } 
}

export const sxRadioGroupTeleorientacao: SxProps = {
    gap: '16px'
}

export const sxRadioTeleorientacao: SxProps = {
    padding: '0px 9px'
}